
let inject = [
    '$scope',
    'eventDetailService',
    'SharedService',
    '$stateParams',

];

class EventDetailController {
    constructor($scope,eventDetailService,SharedService,$stateParams) {
        this.eventDetailService=eventDetailService;
        this.$stateParams=$stateParams;
        this.SharedService=SharedService;
        this.$scope = $scope;
        this.event=[];
        this.eventId = this.$stateParams.eventId || '';
        this.pageName = "PAG-42";


        this.SharedService.getCMSBanners(this.pageName).then(response => {
          this.cmsData = response;
          this.shCtrl.setTags(this.cmsData.seo);
        });
    }

    $onInit() {
      this.eventDetailService.getEvent(this.$stateParams.eventId).then(response=>{
        this.event=response.data[0];


      });
    }



}

EventDetailController.$inject = inject;

export default EventDetailController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/events/event-detail/event-detail.controller.js
 **/